<script setup lang="ts">
import { CheckCircle, XCircle, AlertCircle, Info } from "lucide-vue-next";
import { isVNode } from "vue";
import Toast from "./Toast.vue";
import ToastAction from "./ToastAction.vue";
import ToastClose from "./ToastClose.vue";
import ToastDescription from "./ToastDescription.vue";
import ToastProvider from "./ToastProvider.vue";
import ToastTitle from "./ToastTitle.vue";
import ToastViewport from "./ToastViewport.vue";
import { useToast } from "./use-toast";

const { toasts } = useToast();

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const iconMap: Record<string, any> = {
  success: CheckCircle,
  error: XCircle,
  warning: AlertCircle,
  info: Info,
  default: null,
  destructive: XCircle,
};
</script>

<template>
  <ToastProvider>
    <template v-for="toast in toasts" :key="toast.id">
      <Toast v-bind="toast">
        <div class="flex gap-3">
          <component
            :is="iconMap[toast.variant || 'default']"
            v-if="iconMap[toast.variant || 'default']"
            :class="{
              'h-5 w-5': true,
              'text-pando-green-primary': toast.variant === 'success',
              'text-error':
                toast.variant === 'error' || toast.variant === 'destructive',
              'text-pando-orange-semantics': toast.variant === 'warning',
              'text-pando-blue-primary': toast.variant === 'info',
            }"
          />
          <div class="grid gap-1">
            <ToastTitle v-if="toast.title">
              {{ toast.title }}
            </ToastTitle>
            <template v-if="toast.description">
              <ToastDescription v-if="isVNode(toast.description)">
                <component :is="toast.description" />
              </ToastDescription>
              <ToastDescription v-else>
                {{ toast.description }}
              </ToastDescription>
            </template>
          </div>
        </div>
        <ToastClose />
        <ToastAction
          v-if="toast.action"
          :altText="toast.action.altText"
          @click="toast.action.action"
        >
          {{ toast.action.label }}
        </ToastAction>
      </Toast>
    </template>
    <ToastViewport />
  </ToastProvider>
</template>
